import L from "leaflet";
import DesImg from "../../../assets/destination.png";
import OrgImg from "../../../assets/origin.png";
import NavImg from "../../../assets/navigation1.png";
import OriginImg from "../../../assets/OriginFinal.png";

const simIcon = new L.divIcon({
  className: "custom-marker",
  html: '<div style="background-color: #108200; width: 10px; height: 10px; border-radius: 50%;"></div>',
  iconSize: [20, 20],
});

const appIcon = new L.divIcon({
  className: "custom-marker",
  html: '<div style="background-color: #FE8100; width: 10px; height: 10px; border-radius: 50%;"></div>',
  iconSize: [20, 20],
});

const fastTagIcon = new L.divIcon({
  className: "custom-marker",
  html: '<div style="background-color: #2363F2; width: 10px; height: 10px; border-radius: 50%;"></div>',
  iconSize: [20, 20],
});

// Creating custom icons with HTML rendering for DesImg, NavImg, and OrgImg using direct inline styles.
const iconDes = new L.divIcon({
  className: "custom-marker",
  html: `<div style="width: 20px; height: 20px;">
            <img src="${DesImg}" alt="Destination" style="width: 100%; height: 100%; object-fit: cover;" />
          </div>`,
  iconSize: [25, 30],
});

const iconNav = new L.divIcon({
  className: "custom-marker",
  html: `<div style="width: 20px; height: 20px;">
            <img src="${NavImg}" alt="Navigation" style="width: 100%; height: 100%; object-fit: cover;" />
          </div>`,
  iconSize: [20, 20],
});

const iconOrg = new L.divIcon({
  className: "custom-marker",
  html: `<div style="width: 20px; height: 20px;">
            <img src="${OrgImg}" alt="Origin" style="width: 100%; height: 100%; object-fit: cover;" />
          </div>`,
  iconSize: [25, 30],
});

const iconOriginO = new L.divIcon({
  className: "custom-marker",
  html: `<div style="width: 24px; height: 24px;">
            <img src="${OriginImg}" alt="Origin" style="width: 100%; height: 100%; object-fit: cover;" />
          </div>`,
  iconSize: [25, 30],
});

const createCustomIcon = (iconHtml) => {
  return L.divIcon({
    className: "custom-marker-container", // New custom class for positioning
    html: iconHtml,
    iconSize: [20, 20], // Adjust size as needed
  });
};

const locationIcon = new L.divIcon({
  className: "custom-location-marker",
  html: `
    <div style="background-color: black; width: 18px; height: 18px; border-radius: 50%; position: relative; border: 2px solid white;">
      <div style="position: absolute; left: 50%; bottom: 0; transform: translate(-50%, 50%); width: 0; height: 0; border-left: 9px solid transparent; border-right: 9px solid transparent; border-top: 9px solid black;"></div>
      <div style="background-color: white; width: 8px; height: 8px; border-radius: 50%; position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);"></div>
    </div>
  `,
  iconSize: [20, 30], // Adjusted icon size to accommodate the border
});

export { simIcon, appIcon, fastTagIcon, iconDes, iconNav, iconOrg, createCustomIcon, locationIcon, iconOriginO };
